// ── CopyTrackingButton — 택배 송장번호 클립보드 복사 버튼 ─────────────────────
// 전 회사(PINE/DOT/LNJ) + 관리자 정산서 공통 단일 소스.
// 수정하면 모든 정산서에 즉시 반영됩니다.
//
// @param {string} text — 복사할 텍스트 (예: "CJ대한통운 1234567890")
import React, { useState } from 'react';

export function CopyTrackingButton({ text }) {
  const [copied, setCopied] = useState(false);

  // 클립보드에 텍스트를 복사하고 2초 후 상태를 원래대로 복원
  async function handleCopy(e) {
    e.stopPropagation();
    const t = String(text || '').trim();
    if (!t) return;
    try {
      await navigator.clipboard.writeText(t);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (_) {
      // 클립보드 API 미지원 환경에서는 조용히 실패
    }
  }

  return (
    <button
      type="button"
      onClick={handleCopy}
      style={{
        background:   copied ? '#dcfce7' : 'var(--bg-subtle)',
        border:       `1px solid ${copied ? '#86efac' : 'var(--border)'}`,
        borderRadius: 5,
        padding:      '2px 6px',
        cursor:       'pointer',
        display:      'inline-flex',
        alignItems:   'center',
        gap:          3,
        fontSize:     10,
        fontWeight:   600,
        color:        copied ? '#15803d' : 'var(--text-muted)',
        transition:   'all 0.18s',
        whiteSpace:   'nowrap',
        flexShrink:   0,
      }}
    >
      {copied ? (
        <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
          <polyline points="20 6 9 17 4 12" />
        </svg>
      ) : (
        <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <rect x="9" y="9" width="13" height="13" rx="2" ry="2" />
          <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
        </svg>
      )}
      {copied ? '복사됨' : '송장복사'}
    </button>
  );
}
